var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.544 511.544",
    height: 512,
    viewBox: "0 0 511.544 511.544",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m463.188 347.906h40.06v40.06h-40.06z",
    transform: "matrix(.707 -.707 .707 .707 -118.637 449.466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.218 441.169c-6.307.664-14.105-5.627-18.601-10.897v41.267c0 10.273 8.328 18.601 18.601 18.601s18.601-8.328 18.601-18.601v-41.267c-4.649 5.079-10.547 10.942-18.601 10.897z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.799 21.587-230.776 83.577c-2.686.973-2.7 4.767-.021 5.76l226.89 84.05c.679.251 1.425.255 2.106.009l233.901-84.327c2.7-.974 2.703-4.792.004-5.769l-230.015-83.3c-.675-.244-1.414-.244-2.089 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.164 232.668c-2.038.735-4.173 1.102-6.308 1.102-2.188 0-4.378-.386-6.462-1.159l-162.767-60.296v111.609c0 2.846 1.079 5.58 3.032 7.65 11.022 11.682 54.351 48.099 166.197 48.099 111.796 0 156.307-36.381 167.729-48.079 2.034-2.083 3.162-4.875 3.162-7.786v-110.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.617 150.305v155.294c12.738-15.812 26.504-12.854 37.203 0v-168.706z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.0da3bd48.svg";
export { ForwardRef as ReactComponent };